import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export type ToastType = 'none' | 'info' | 'error';

type ToastProps = {
  type: ToastType;
  msg: string | React.ReactNode;
  infinity?: boolean;
};

const initState: ToastProps = {
  type: 'none',
  msg: '',
  infinity: false
};

const toastSlice = createSlice({
  name: 'toast',
  initialState: initState,
  reducers: {
    initToast: () => initState,
    activeToast: (state, action: PayloadAction<ToastProps>) => {
      state = { ...action.payload };
      return state;
    }
  }
});

export const { initToast, activeToast } = toastSlice.actions;
export const selectToast = (state: RootState) => state.toast;
export default toastSlice.reducer;
